import { useCallback, useMemo, useState, type ReactNode } from "react";
import {
  AgentFocusContext,
  type AgentContext,
  type AgentFocusContextValue,
} from "src/components/llm/agent-focus/agent-focus";

/** Owns the typed context snapshot shared by v1 and v2 chats. */
export function AgentFocusProvider({ children }: { children: ReactNode }) {
  const [context, updateContext] = useState<AgentContext>({});
  const setContext: AgentFocusContextValue["setContext"] = useCallback(
    (key, value) => {
      updateContext((current) => ({ ...current, [key]: value }));
    },
    [],
  );
  const clearContext: AgentFocusContextValue["clearContext"] = useCallback(
    (key) => {
      updateContext((current) => {
        const { [key]: _removed, ...remaining } = current;
        return remaining;
      });
    },
    [],
  );
  const value = useMemo(
    () => ({ context, setContext, clearContext }),
    [context, setContext, clearContext],
  );
  return (
    <AgentFocusContext.Provider value={value}>
      {children}
    </AgentFocusContext.Provider>
  );
}
